import {
    faBuilding,
    faBolt,
    faChartColumn,
    faUserShield,
    faGear,
} from '@fortawesome/free-solid-svg-icons';
import {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {Role} from '../../utils/roles';

export interface NavItem {
    path: string;
    icon: IconDefinition;
    label: string;
    /** Mô tả ngắn hiện dưới tiêu đề trang ở header */
    subtitle: string;
    /** Vai trò thấy được mục này - PHẢI khớp RoleGuard của route trong App.tsx */
    roles: Role[];
}

const STAFF: Role[] = ['admin', 'manager', 'viewer'];

/**
 * Menu của chủ nhà. Thứ tự theo tần suất dùng thật: ghi điện nước là việc làm
 * hằng tháng nên đứng ngay sau danh sách phòng, không nằm cuối.
 *
 * `roles` ở đây chỉ để ẩn/hiện cho gọn mắt - chặn thật nằm ở RoleGuard (route)
 * và database.rules.json (server).
 *
 * Không có mục "Trang chủ": bấm logo ở đầu sidebar là về rồi, thêm một dòng nữa
 * chỉ tốn chỗ của những mục dùng hằng ngày.
 */
export const NAV_ITEMS: NavItem[] = [
    {path: '/phong', icon: faBuilding, label: 'Quản lý nhà trọ', subtitle: 'Danh sách phòng & hồ sơ phòng', roles: STAFF},
    {path: '/diennuoc', icon: faBolt, label: 'Ghi điện nước', subtitle: 'Ghi số, duyệt & thu tiền theo tháng', roles: STAFF},
    {path: '/thongke', icon: faChartColumn, label: 'Thống kê', subtitle: 'Tiêu thụ & thanh toán theo tháng', roles: STAFF},
    {path: '/phanquyen', icon: faUserShield, label: 'Người dùng', subtitle: 'Tài khoản & phân quyền', roles: ['admin', 'manager']},
    {path: '/caidat', icon: faGear, label: 'Cài đặt', subtitle: 'Giá mặc định, tài khoản, phòng', roles: ['admin', 'manager']},
];

export const navItemsFor = (role: Role | null): NavItem[] =>
    role ? NAV_ITEMS.filter(item => item.roles.includes(role)) : [];

/** Mục menu khớp với đường dẫn hiện tại (khớp tiền tố, ưu tiên đường dẫn dài nhất) */
export const findActiveNav = (pathname: string): NavItem | undefined =>
    NAV_ITEMS
        .filter(item => pathname === item.path || pathname.startsWith(`${item.path}/`))
        .sort((a, b) => b.path.length - a.path.length)[0];
